import { Badge, Card, Modal } from "react-bootstrap";
import styled from "styled-components";

export const StyledModalBody = styled(Modal.Body)`
  max-height: 80vh;
  overflow-y: auto;
  padding: 1.5rem;
`;

export const EmptyStateContainer = styled.div`
  text-align: center;
  padding: 2rem 0;
  color: #6c757d;
`;

export const CardsContainer = styled.div`
  display: grid;
  gap: 1rem;
`;

export const StyledCard = styled(Card)`
  border: 1px solid #dee2e6;
`;

export const CardHeaderContent = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding-bottom: 0.75rem;
`;

export const CardHeaderLeft = styled.div`
  display: grid;
  gap: 0.5rem;
`;

export const ActionBadge = styled(Badge)`
  font-size: 0.75rem;
  font-weight: 500;
  text-transform: capitalize;
  background-color: ${(props) => props.color || "#6c757d"};
  color: #fff;
`;

export const ObjectIdText = styled.span`
  font-size: 0.875rem;
  color: #6c757d;
`;

export const CardTitleStyled = styled(Card.Title)`
  font-size: 1.125rem;
  margin-bottom: 0;
`;

export const CardDescriptionText = styled(Card.Text)`
  font-size: 0.875rem;
  color: #6c757d; /* text-muted-foreground */
  margin-bottom: 0;
`;

export const CardHeaderRight = styled.div`
  text-align: right;
  font-size: 0.875rem;
  color: #6c757d;
`;

export const ActorInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 0.25rem;
  margin-bottom: 0.25rem;
`;

export const TimestampInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 0.25rem;
`;

export const CardBodyContent = styled(Card.Body)`
  display: grid;
  gap: 0.75rem;
`;

export const ResourceTypeInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.875rem;
  font-weight: 500;
`;

export const ResourceBadge = styled.div`
  border: 1px solid #dee2e6;
  color: #212529;
  background-color: #f8f9fa;
  border-radius: 8px;
  padding: 2px 2px;
  font-size: 0.75rem;
`;

export const ChangesSection = styled.div`
  display: grid;
  gap: 0.75rem;
`;

export const ChangesTitle = styled.h4`
  font-weight: 500; /* font-medium */
  margin-bottom: 0.75rem; /* mb-3 */
`;

export const ChangeItem = styled.div`
  border: 1px solid #dee2e6;
  border-radius: 0.5rem;
  padding: 0.75rem;
  background-color: rgba(248, 249, 250, 0.3);
`;

export const FieldName = styled.div`
  font-weight: 500;
  margin-bottom: 0.5rem;
  font-size: 0.875rem;
`;

export const FieldNameHighlight = styled.span`
  color: #007bff;
`;

export const ChangeGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 0.5rem;

  @media (min-width: 768px) {
    grid-template-columns: repeat(3, 1fr);
  }
  align-items: center;
`;

export const ChangeValueContainer = styled.div`
  display: grid;
  gap: 0.25rem;
`;

export const ChangeLabelBefore = styled.div`
  font-size: 0.75rem;
  font-weight: 500;
  color: #dc3545;
`;

export const ChangeValueBefore = styled.div`
  padding: 0.5rem;
  background-color: #f8d7da;
  border: 1px solid #f5c6cb;
  border-radius: 0.25rem;
  font-size: 0.875rem;
  word-break: break-words;
`;

export const ChangeSeparator = styled.div`
  display: flex;
  justify-content: center;
`;

export const ChangeLabelAfter = styled.div`
  font-size: 0.75rem;
  font-weight: 500;
  color: #28a745;
`;

export const ChangeValueAfter = styled.div`
  padding: 0.5rem;
  background-color: #d4edda;
  border: 1px solid #c3e6cb;
  border-radius: 0.25rem;
  font-size: 0.875rem;
  word-break: break-words;
`;
